var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: [_vm.$style.previewField] }, [
    _c(
      "div",
      { class: _vm.$style.name, style: { width: `${_vm.ratio[0] * 100}%` } },
      [_vm._v(" " + _vm._s(_vm.name) + " ")]
    ),
    _c(
      "div",
      { class: _vm.$style.value, style: { width: `${_vm.ratio[1] * 100}%` } },
      [_vm._v(" " + _vm._s(_vm.value) + " ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }